<svelte:options runes={true} />

<script lang="ts">
  import Menu from './Menu.svelte';
  import type { MenuConfig } from './menu-types.js';

  let {
    menus
  }: {
    menus: MenuConfig[];
  } = $props();
</script>

<style>
  .menu-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: var(--sl-color-neutral-50);
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: 0;
    margin: 0;
  }
</style>

<div class="menu-bar">
  {#each menus as menu}
    <Menu items={menu.items} label={menu.label} />
  {/each}
</div>
